import { createStore } from 'satcheljs';
import { createLockedCalendarEventsStore } from 'owa-calendar-events-store';

export interface CalendarSurfaceEventsLockedStore {
    surfaceEventsLockId;
}

let calendarStoreData: CalendarSurfaceEventsLockedStore = {
    surfaceEventsLockId: createLockedCalendarEventsStore().getLockId(), // As there will be one top level lock for surface hence creating it here
};

export let getStore = createStore<CalendarSurfaceEventsLockedStore>(
    'calendarSurfaceEventsLockedStore',
    calendarStoreData
);
